module.exports = __webpack_public_path__ + "img/vdara1.98f0099c.jpg";